import { Component, input } from '@angular/core';

@Component({
    selector: 'r1-compass-app-welcome-message',
    template: `
        <div id="background">
            <h1 data-testid="title">{{ title() }}</h1>
            <p>
                <strong data-testid="subtitle">{{ subtitle() }}</strong>
            </p>
            <p data-testid="announcement">
                <strong>Announcement</strong>:
                <ng-content />
            </p>
        </div>
    `,
    styles: `
        #background {
            background-image: url('/assets/r1_appcloud_msg_bg.jpeg');
            color: var(--r1-white);
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 1rem;
            box-sizing: border-box;
        }

        p {
            margin-bottom: 100px;
        }
    `,
})
export class WelcomeMessageComponent {
    title = input.required<string>();
    subtitle = input.required<string>();
}
